import { BLOCK_SEPARATOR } from "@tiptap-content/util/markdown-template"
import { getTextBetween, getTextSerializersFromSchema, type Editor } from "@tiptap/core"
import type { Slice } from "@tiptap/pm/model"

/**
 * Gets the plaintext corresponding to a slice for editor.
 *
 * This function makes use of extensions' renderText functions - unlike Tiptap's
 * getText, which skips the outermost node's renderText function.
 */
export function getSliceText(editor: Editor, slice: Slice): string {
  return getTextBetween(
    // Create a synthetic parent node for the Slice content (non-checked).
    editor.schema.topNodeType.create(null, slice.content),
    { from: 0, to: slice.content.size },
    {
      blockSeparator: BLOCK_SEPARATOR,
      textSerializers: getTextSerializersFromSchema(editor.schema),
    },
  )
}
